<template>
    <div class="container mx-auto p-4">
      <div class="flex flex-col">
        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Recinto</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Evento</th>
                <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">Stands</th>
                <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">Simposios</th>
                <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">OP</th>
                <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">Acciones</th>
                <!-- <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">Acciones</th> -->
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="row in planosPorEvento" :key="row.id_recinto + '-' + row.id_evento">
                <td class="px-6 py-4 whitespace-nowrap">{{ row.nombre_recinto }}</td>
                <td class="px-6 py-4 whitespace-nowrap">{{ row.nombre_evento }}</td>
                <td class="px-6 py-4 text-center">
                  <div v-if="row.stand" class="flex flex-col gap-2 items-center">
                    <button @click="descargarExcel(row.stand.id_plano)" class="bg-green-100 text-green-800 px-3 py-1 rounded shadow hover:bg-green-200 w-24">Excel</button>
                    <button @click="openSVGModal(row.stand)" class="bg-blue-100 text-blue-800 px-3 py-1 rounded shadow hover:bg-blue-200 w-24">SVG</button>
                    <button @click="editPlano(row.stand)" class="bg-yellow-100 text-yellow-800 px-3 py-1 rounded shadow hover:bg-yellow-200 w-24">Editar</button>
                  </div>
                  <div v-else class="flex justify-center">
                    <button @click="agregarTipo(row, 'stand')" class="bg-gray-100 text-gray-800 px-3 py-1 rounded shadow hover:bg-gray-200 w-24">Agregar</button>
                  </div>
                </td>
                <td class="px-6 py-4 text-center">
                  <div v-if="row.simposio" class="flex flex-col gap-2 items-center">
                    <button @click="descargarExcel(row.simposio.id_plano)" class="bg-green-100 text-green-800 px-3 py-1 rounded shadow hover:bg-green-200 w-24">Excel</button>
                    <button @click="openSVGModal(row.simposio)" class="bg-blue-100 text-blue-800 px-3 py-1 rounded shadow hover:bg-blue-200 w-24">SVG</button>
                    <button @click="editPlano(row.simposio)" class="bg-yellow-100 text-yellow-800 px-3 py-1 rounded shadow hover:bg-yellow-200 w-24">Editar</button>
                  </div>
                  <div v-else class="flex justify-center">
                    <button @click="agregarTipo(row, 'simposio')" class="bg-gray-100 text-gray-800 px-3 py-1 rounded shadow hover:bg-gray-200 w-24">Agregar</button>
                  </div>
                </td>
                <td class="px-6 py-4 text-center">
                  <div v-if="row.op" class="flex flex-col gap-2 items-center">
                    <button @click="descargarExcel(row.op.id_plano)" class="bg-green-100 text-green-800 px-3 py-1 rounded shadow hover:bg-green-200 w-24">Excel</button>
                    <button @click="openSVGModal(row.op)" class="bg-blue-100 text-blue-800 px-3 py-1 rounded shadow hover:bg-blue-200 w-24">SVG</button>
                    <button @click="editPlano(row.op)" class="bg-yellow-100 text-yellow-800 px-3 py-1 rounded shadow hover:bg-yellow-200 w-24">Editar</button>
                  </div>
                  <div v-else class="flex justify-center">
                    <button @click="agregarTipo(row, 'op')" class="bg-gray-100 text-gray-800 px-3 py-1 rounded shadow hover:bg-gray-200 w-24">Agregar</button>
                  </div>
                </td>
                <td class="px-6 py-4 text-center">
                  <div class="flex justify-center">
                    <button
                      class="bg-orange-200 text-gray-800 px-3 py-1 rounded shadow hover:bg-orange-300 "
                      @click="irAReservasAdmin(row.id_recinto, row.id_evento)"
                    >
                      Administrar
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>

          </table>
        </div>
      </div>
      <button @click="showCreateModal = true" class="mt-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
        Generar nueva asignación
      </button>
      <PlanoEventoModal
        v-if="showCreateModal"
        @close="showCreateModal = false"
        @saved="fetchPlanos"
      />
      <PlanoEventoModal
        v-if="planoToEdit"
        :plano="planoToEdit"
        @close="planoToEdit = null"
        @saved="handleEditSaved"
      />
      <!-- Modal SVGs -->
        <transition name="fade">
        <div
            v-if="showSVGModal"
            class="fixed inset-0 bg-gray-900 bg-opacity-40 flex items-center justify-center z-50"
        >
            <div class="bg-white rounded-lg shadow-lg p-6 min-w-[320px] max-w-md w-full">
            <div class="flex justify-between items-center mb-4">
                <div class="text-lg font-bold">SVGs de {{ currentPlano?.nombre_recinto }}</div>
                <button @click="showSVGModal = false" class="text-red-500 text-xl font-bold">&times;</button>
            </div>
            <div v-if="svgsInModal.length">
                <ul>
                <li v-for="svg in svgsInModal" :key="svg.file" class="flex items-center justify-between py-2 border-b">
                    <span>{{ svg.label }}</span>
                    <button
                    @click="descargarSVGArchivo(svg.file)"
                    class="text-blue-600 hover:text-blue-900 px-2 py-1 border border-blue-200 rounded ml-4"
                    >Descargar</button>
                </li>
                </ul>
            </div>
            <div v-else>
                <span class="text-gray-500">No hay SVGs cargados.</span>
            </div>
            </div>
        </div>
        </transition>

    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, computed } from 'vue';
  import { useToast } from "vue-toastification";
  import { useRouter } from 'vue-router'
  const router = useRouter()
  import PlanoEventoModal from '@/components/modals/planos/PlanoEventoModal.vue';
  
  // const router = useRouter();
  const planos = ref([]);
  const showCreateModal = ref(false);
  const planoToEdit = ref(null);
  const toast = useToast();
  const showSVGModal = ref(false);
const svgsInModal = ref([]);
const currentPlano = ref(null);

function openSVGModal(plano) {
  // Decodifica archivo_svg (que puede venir como string)
  let svgs = [];
  try {
    svgs = Array.isArray(plano.archivo_svg) ? plano.archivo_svg : JSON.parse(plano.archivo_svg);
  } catch {
    svgs = [];
  }
  svgsInModal.value = svgs;
  currentPlano.value = plano;
  showSVGModal.value = true;
}
function irAReservasAdmin(id_recinto, id_evento) {
  router.push(`/admin-reservas/${id_recinto}/${id_evento}`)
}
function descargarSVGArchivo(filename) {
  // Puedes cambiar la ruta según tu API
  window.open(`/api/planos-evento/svgfile/${filename}`, '_blank');
}

// function goToTester(id_plano) {
//   router.push({ name: 'PlanosTester', params: { id_plano } });
// }

const planosPorEvento = computed(() => {
  // Group by id_recinto+id_evento
  const map = {};
  planos.value.forEach(plano => {
    const key = plano.id_recinto + '-' + plano.id_evento;
    if (!map[key]) {
      map[key] = {
        id_recinto: plano.id_recinto,
        id_evento: plano.id_evento,
        nombre_recinto: plano.nombre_recinto,
        nombre_evento: plano.nombre_evento,
        stand: null,
        simposio: null,
        op: null
      };
    }
    if (plano.tipo === 'stand') map[key].stand = plano;
    if (plano.tipo === 'simposio') map[key].simposio = plano;
    if (plano.tipo === 'op') map[key].op = plano;
  });
  return Object.values(map);
});

  function fetchPlanos() {
    fetch('/api/planos-evento')
      .then(res => res.json())
      .then(data => planos.value = data)
      .catch(() => toast.error("Error al cargar las asignaciones"));
  }
  function descargarExcel(id) {
    window.open(`/api/planos-evento/excel/${id}`, '_blank');
  }

  // function toggleActivo(plano) {
  //   fetch(`/api/planos-evento/toggle/${plano.id_plano}`, { method: 'POST' })
  //     .then(res => res.json())
  //     .then(data => {
  //       plano.activo = data.activo;
  //       toast.success(data.activo ? "Asignación activada" : "Asignación desactivada");
  //     })
  //     .catch(() => toast.error("Error al cambiar el estado"));
  // }
  function editPlano(plano) {
    planoToEdit.value = { ...plano };
  }
  function handleEditSaved() {
    planoToEdit.value = null;
    fetchPlanos();
  }
  function agregarTipo(row, tipo) {
  planoToEdit.value = {
    id_recinto: row.id_recinto,
    id_evento: row.id_evento,
    tipo: tipo,
    archivo_excel: '',
    archivo_svg: ''
  };
  showCreateModal.value = true;
}
  onMounted(fetchPlanos);
  </script>
  
  <style lang="sass" scoped>
  .switch-container
    display: inline-block
    width: 46px
    height: 26px
    position: relative
  
    input
      opacity: 0
      width: 0
      height: 0
  
    .slider
      position: absolute
      cursor: pointer
      top: 0
      left: 0
      right: 0
      bottom: 0
      background-color: #ccc
      transition: .4s
      border-radius: 26px
  
    input:checked + .slider
      background-color: #22c55e
  
    .slider:before
      position: absolute
      content: ""
      height: 22px
      width: 22px
      left: 2px
      bottom: 2px
      background-color: white
      transition: .4s
      border-radius: 50%
  
    input:checked + .slider:before
      transform: translateX(20px)
td
  vertical-align: middle
  text-align: center

  </style>
  